const PERCENTAGE = "%";
const QUANTITY = "$";
const PRECIO_STRING = "precio";
export const BULK_EDIT_UNITS = {
  PRECIO: PRECIO_STRING,
  PRECIO$: `${QUANTITY}` as const,
  PRECIO_PERCENTAGE: `${PERCENTAGE}` as const,
} as const;

export const BULK_EDIT_FULL_OPTIONS = {
  PRECIO_ADD: `+${PRECIO_STRING}` as const,
  PRECIO_SUBTRACT: `-${PRECIO_STRING}` as const,
  STOCK: "stock" as const,
  PROMO: "promo" as const,
  DESTACADO: "destacado" as const,
} as const;

export const AllowedMethodsForPriceModification = [
  PERCENTAGE,
  QUANTITY,
] as const;

type ModifyPriceByPERCENTAGE = typeof PERCENTAGE;
type ModifyPriceByQUANTITY = typeof QUANTITY;

export type MethodForPriceModification =
  | ModifyPriceByPERCENTAGE
  | ModifyPriceByQUANTITY;

export type BulkEditOptionsType =
  (typeof BULK_EDIT_FULL_OPTIONS)[keyof typeof BULK_EDIT_FULL_OPTIONS];

export type BulkEditOptionsTypeAndEmptyString = BulkEditOptionsType | "";
